import '../js/theme-init.js'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from '../components/App.vue'
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import '../css/main.css'

// Define routes
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes
})

// Create and mount app
const app = createApp(App)
app.use(router)
app.mount('#app')

